import React, { useState } from "react";
import BackgroundImg from "../assets/background.jpg";

const Button = ({ children, className = '', ...props }) => (
  <button
    className={`bg-gray-600 hover:bg-gray-700 font-semibold rounded-full px-4 py-2 transition ${className}`}
    {...props}
  >
    {children}
  </button>
);

const Card = ({ children, className = '' }) => (
  <div className={`bg-white rounded-xl border shadow-sm ${className}`}>{children}</div>
);

const CardContent = ({ children, className = '' }) => (
  <div className={`p-4 ${className}`}>{children}</div>
);

const models = [
  { type: "M", name: "R3" },
  { type: "M", name: "R15M" },
  { type: "M", name: "R15 V4" },
  { type: "M", name: "R15S" },
  { type: "M", name: "MT-03" },
  { type: "M", name: "MT-15 Ver 2.0" },
  { type: "M", name: "FZ-S Fi Hybrid" },
  { type: "M", name: "FZ-S Fi" },
  { type: "M", name: "FZ-Fi" },
  { type: "M", name: "FZ-X" },
  { type: "S", name: "Aerox 155 Version S" },
  { type: "S", name: "Aerox 155" },
  { type: "S", name: "RayZR 125 Fi Street Rally" },
  { type: "S", name: "RayZR 125 Fi" },
  { type: "S", name: "Fascino 125 Fi" },
];

const groupedModels = models.reduce((acc, model) => {
  const type = model.type === "M" ? "Motorcycles" : "Scooters";
  if (!acc[type]) acc[type] = [];
  acc[type].push(model);
  return acc;
}, {});

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    model: "",
    message: "",
  });

  const encode = (data) => {
  return Object.keys(data)
    .map(
      (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
    )
    .join("&");
};


const handleSubmit = (e) => {
  e.preventDefault();

  fetch("/", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: encode({ "form-name": "contact", ...formData }),
  })
    .then(() => {
      alert("Form submitted successfully!");
      setFormData({
        name: "",
        email: "",
        mobile: "",
        model: "",
        message: "",
      }); // ← clears the form
    })
    .catch((error) => alert("Error submitting form: " + error));
};

const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prevData) => ({
    ...prevData,
    [name]: value,
  }));
};



  return (
    <section id="contact" className="py-16 scroll-mt-10 bg-gray-950 text-white relative overflow-hidden">
      {/* 50% opacity background image */}
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-50 z-0" 
        style={{ backgroundImage: `url(${BackgroundImg})` }}
      ></div>
      {/* Blue gradient overlay for gorgeous brand styling */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-950/90 via-blue-900/60 to-indigo-950/90 z-0"></div>

      <div className="container mx-auto px-6 text-center relative z-10">
        <h2 className="text-4xl font-extrabold mb-2 tracking-wide text-white">Contact Us</h2>
        <p className="text-blue-200 mb-8 max-w-md mx-auto text-sm sm:text-base">
          Have questions or want to schedule a test ride? Fill out the form below and our representative will reach out to you shortly!
        </p>

        <form
          name="contact"
          onSubmit={handleSubmit}
          className="max-w-xl mx-auto bg-[#faf8f4] border border-[#e8dfd0] p-8 sm:p-10 rounded-2xl shadow-2xl text-left text-gray-800 relative z-10"
          method="POST"
          data-netlify="true"
        >
          <div className="mb-5">
            <label className="block text-sm font-bold text-gray-700 mb-2">Full Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-3 bg-white border border-[#cfc0a8] rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-700 focus:border-transparent transition"
              placeholder="Enter your full name"
              required
            />
          </div>

          <div className="mb-5">
            <label className="block text-sm font-bold text-gray-700 mb-2">Email Address</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-3 bg-white border border-[#cfc0a8] rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-700 focus:border-transparent transition"
              placeholder="Enter your email address"
              required
            />
          </div>

          <div className="mb-5">
            <label className="block text-sm font-bold text-gray-700 mb-2">Mobile Number</label>
            <input
              type="tel"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              className="w-full p-3 bg-white border border-[#cfc0a8] rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-700 focus:border-transparent transition"
              placeholder="Enter 10-digit mobile number"
              pattern="[0-9]{10}"
              required
            />
          </div>

          <div className="mb-5">
            <label className="block text-sm font-bold text-gray-700 mb-2">Interested Yamaha Model</label>
            <select
              name="model"
              value={formData.model}
              onChange={handleChange}
              className={`w-full p-3 bg-white border border-[#cfc0a8] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-700 focus:border-transparent transition ${
                formData.model === '' ? 'text-gray-400' : 'text-gray-900'
              }`}
              required
            >
              <option value="" className="text-gray-400">Select a Yamaha Model</option>
              {Object.entries(groupedModels).map(([group, models]) => (
                <optgroup key={group} label={group} className="text-gray-500 font-bold bg-white">
                  {models.map((model) => (
                    <option key={model.name} value={model.name} className="text-gray-900 font-normal bg-white">
                      {model.name}
                    </option>
                  ))}
                </optgroup>
              ))}
            </select>
          </div>

          <div className="mb-6">
            <label className="block text-sm font-bold text-gray-700 mb-2">Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="w-full p-3 bg-white border border-[#cfc0a8] rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-700 focus:border-transparent transition"
              rows="4"
              placeholder="Write your message here..."
              required
            ></textarea>
          </div>

          <div className="text-center">
            <button
              type="submit"
              className="w-full sm:w-auto bg-blue-800 hover:bg-blue-900 text-white font-bold py-3 px-8 rounded-lg shadow-lg hover:shadow-xl transition duration-300 transform hover:scale-[1.02] active:scale-95"
            >
              Submit Inquiry
            </button>
          </div>
          <input type="hidden" name="form-name" value="contact" />
        </form>
      </div>
    </section>
  );
};

export default ContactUs;
